module.exports = __webpack_public_path__ + "e0e6b3e643491909be09f22ece12aae4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/fuehrer.svg
// module id = 16
// module chunks = 0